import { SxProps } from '@mui/material'

import theme from '../../../../styles/themes/default.theme'

const styles = {
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
      gap: theme.spacing(2)
    }
  } as SxProps,

  fieldText: {
    color: theme.palette.grey[500],
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  } as SxProps
}

export default styles
